import React from "react";
import cx from "classnames";

import type { BaseFieldProps } from "./types";

export interface CheckboxProps extends BaseFieldProps {
  className?: string;
  inline?: boolean;
  value?: React.InputHTMLAttributes<HTMLInputElement>["value"];
  checked?: boolean;
}

export const Checkbox: React.FC<CheckboxProps> = ({
  className,
  label,
  id,
  name,
  onChange,
  onBlur,
  error,
  touched,
  children,
  inline,
  checked,
  ...rest
}) => {
  id = id || name;
  return (
    <div
      className={cx(
        "custom-control custom-checkbox",
        {
          "custom-control-inline": inline,
        },
        className,
      )}
    >
      <input
        type="checkbox"
        className={cx("custom-control-input", {
          "is-invalid": error && touched,
        })}
        id={id}
        name={name}
        onChange={onChange}
        onBlur={onBlur}
        {...rest}
      />
      <label className="custom-control-label" htmlFor={id}>
        {label}
      </label>
    </div>
  );
};

export interface RadioProps extends Omit<BaseFieldProps, "id"> {
  className?: string;
  inline?: boolean;
  value?: React.InputHTMLAttributes<HTMLInputElement>["value"];
  id: string;
  checked?: boolean;
}

export const Radio: React.FC<RadioProps> = ({
  className,
  label,
  id,
  name,
  onChange,
  onBlur,
  error,
  touched,
  children,
  inline,
  checked,
  ...rest
}) => {
  return (
    <div
      className={cx(
        "form-check",
        {
          "form-check-inline": inline,
        },
        className,
      )}
    >
      <input
        type="radio"
        className={cx("form-check-input", {
          "is-invalid": error && touched,
        })}
        id={id}
        name={name}
        onChange={onChange}
        onBlur={onBlur}
        checked={!!checked}
        {...rest}
      />
      <label className="form-check-label" htmlFor={id}>
        {label}
      </label>
    </div>
  );
};
